import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Compute the current UTC offset as a fixed "+HH:MM" string (e.g. "+02:00" for CEST).
 * We intentionally avoid sending the IANA timezone name (e.g. "Europe/Rome") because
 * MongoDB $dateTrunc does not correctly apply DST for IANA names — it treats them as
 * fixed UTC+1 (CET) year-round. Sending the actual current offset lets MongoDB use the
 * right bucket boundaries for summer (CEST = +02:00) and winter (CET = +01:00).
 */
function getCurrentUtcOffset(): string {
  const offsetMinutes = -new Date().getTimezoneOffset(); // negative of getTimezoneOffset gives UTC+
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const abs = Math.abs(offsetMinutes);
  const hh = String(Math.floor(abs / 60)).padStart(2, '0');
  const mm = String(abs % 60).padStart(2, '0');
  return `${sign}${hh}:${mm}`;
}

export const TimezoneInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  let newReq = req;
  if (req.url.includes(environment.baseUrl)) {
    const headers = req.headers.set('x-sentinel-timezone', getCurrentUtcOffset());
    newReq = req.clone({ headers });
  }

  return next(newReq);
};
